import { c as _c } from "react/compiler-runtime";
import { CONTACT_ID_PARAMETER, DEAL_ID_PARAMETER, EMAIL_PARAMETER, PROJECT_ID_PARAMETER, PROPERTY_ID_PARAMETER, SKIP_QUALIFICATION_PARAMETER } from "@justhome/common/constants";
import useLeadFromQuery from "@lib/hooks/useLeadFromQuery";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { useRouter } from "@lib/hooks/useRouter";
const useBookingParams = () => {
  const $ = _c(9);
  const router = useRouter();
  const {
    state
  } = useApplicationContext();
  const leadFromQuery = useLeadFromQuery();
  const projectId = router.query[PROJECT_ID_PARAMETER] as string | undefined;
  const dealId = router.query[DEAL_ID_PARAMETER] as string | undefined;
  const propertyId = router.query[PROPERTY_ID_PARAMETER] as string | undefined;
  const contactId = router.query[CONTACT_ID_PARAMETER] as string | undefined;
  const skipQualification = router.query[SKIP_QUALIFICATION_PARAMETER] as string | undefined;
  const emailFromQuery = router.query[EMAIL_PARAMETER] as string | undefined;
  const lead = state.lead ?? leadFromQuery ?? undefined;
  const t0 = lead?.projectId ?? projectId;
  const t1 = skipQualification === "true";
  let t2;
  if ($[0] !== contactId || $[1] !== dealId || $[2] !== emailFromQuery || $[3] !== lead || $[4] !== propertyId || $[5] !== router.isReady || $[6] !== t0 || $[7] !== t1) {
    t2 = {
      isReady: router.isReady,
      lead,
      projectId: t0,
      dealId,
      propertyId,
      contactId,
      skipQualification: t1,
      emailFromQuery
    };
    $[0] = contactId;
    $[1] = dealId;
    $[2] = emailFromQuery;
    $[3] = lead;
    $[4] = propertyId;
    $[5] = router.isReady;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default useBookingParams;